import type { PatternSpecificationEnum } from '@hvf/contracts'
import type { Component } from 'solid-js'
import Chip from './Chip'

type SpecificationBadgeProps = {
  patternSpecification?: PatternSpecificationEnum | null
  wrap?: boolean
}

export const specColor = (spec?: PatternSpecificationEnum | null): string => {
  switch (spec) {
    case 'broadly-symmetrical-high-side':
    case 'broadly-symmetrical-low-side':
      return 'var(--colors-editorial-pattern)'
    case 'perfectly-symmetrical':
      return 'var(--colors-editorial-accent)'
    case 'high-slung':
    case 'low-slung':
      return '#e0922a'
    case 'extremely-high-slung':
    case 'extremely-low-slung':
      return 'var(--colors-editorial-chat)'
    default:
      return 'var(--colors-editorial-ink3)'
  }
}

const SpecificationBadge: Component<SpecificationBadgeProps> = (props) => {
  if (!props.patternSpecification) return null

  return (
    <Chip
      color={specColor(props.patternSpecification)}
      tooltip='Pattern Specification'
      wrap={props.wrap}
    >
      {props.patternSpecification.replaceAll('-', ' ')}
    </Chip>
  )
}

export default SpecificationBadge
